import React from "react";
import EditorShell from "../EditorShell";
import { TextField, TextareaField } from "../fields";
import ListArrayEditor from "../ListArrayEditor";
import { whenToUseSchema, SECTION_DEFAULTS } from "../schemas";

const WhenToUseEditor = ({ section, onSaved, onLiveChange }) => (
  <EditorShell
    sectionKey="when_to_use"
    schema={whenToUseSchema}
    defaults={SECTION_DEFAULTS.when_to_use}
    section={section}
    onSaved={onSaved}
    onLiveChange={onLiveChange}
  >
    {(form) => (
      <>
        <TextField form={form} path="title" label="Section title" />
        <TextareaField
          form={form}
          path="description"
          label="Description"
          required
          rows={3}
        />
        <ListArrayEditor
          form={form}
          name="items"
          label="Items"
          max={12}
          newItem={() => ({ icon: "", lead_in: "", description: "" })}
          emptyText="Add bullet items the user might use Aris for."
          renderItem={({ index, form: f }) => (
            <>
              <div className="grid grid-cols-1 sm:grid-cols-[140px_1fr] gap-3">
                <TextField
                  form={f}
                  path={`items.${index}.icon`}
                  label="Icon"
                  hint="moon, refresh, users, compass, clock, loader…"
                />
                <TextField
                  form={f}
                  path={`items.${index}.lead_in`}
                  label="Lead-in (bold)"
                  required
                />
              </div>
              <TextareaField
                form={f}
                path={`items.${index}.description`}
                label="Description"
                rows={2}
                required
              />
            </>
          )}
        />
      </>
    )}
  </EditorShell>
);

export default WhenToUseEditor;
